import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "appSlice",
  initialState: {
    isAdmin: false,
    isLoggedIn: false,
    userInfo: {},
    selectedManualIndex: 0,
    selectedUserInfo: {},
    selectedUserInfo_tec: {},
    selectedStStatus: null,
    boardKindTarget: null,
    videoEduKind: null,
  },
  reducers: {
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setSelectedManualIndex: (state, action) => {
      state.selectedManualIndex = action.payload;
    },
    setSelectedUserInfo: (state, action) => {
      state.selectedUserInfo = action.payload;
    },
    setSelectedUserInfo_tec: (state, action) => {
      state.selectedUserInfo_tec = action.payload;
    },
    setSelectedStStatus: (state, action) => {
      state.selectedStStatus = action.payload;
    },
    setBoardKindTarget: (state, action) => {
      state.boardKindTarget = action.payload;
    },
    setVideoEduKind: (state, action) => {
      state.videoEduKind = action.payload;
    },
  },
});

export const {
  setIsAdmin,
  setIsLoggedIn,
  setUserInfo,
  setSelectedManualIndex,
  setSelectedUserInfo,
  setSelectedUserInfo_tec,
  setSelectedStStatus,
  setBoardKindTarget,
  setVideoEduKind,
} = appSlice.actions;

export default appSlice.reducer;
